<template>
  <el-dialog
    title="更改考勤状态"
    :visible.sync="reviseDialog"
    :before-close="resetForm"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="form-box">
      <el-radio-group v-model="paramObj.name">
          <el-radio :label="0">未签到</el-radio>
          <el-radio :label="1">已签到</el-radio>
          <el-radio :label="2">外勤签到</el-radio>
          <el-radio :label="3">签到异常</el-radio>
          <el-radio :label="4">请假</el-radio>
        </el-radio-group>
    </div>
    <div class="el-dialog__footer">
      <el-button type="primary" plain @click="resetForm">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import dayjs from "dayjs";
import { attendEdit } from "@/api/practiceattendance";
export default {
  name: "addCategory",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reviseDialog: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      paramObj: {
        name: "",
      },
      paramList: [],//带入参数数组
    };
  },
  methods: {
    //加载信息
    loadObj(paramList){
      this.paramList = paramList
    },
    //提交
    submitForm() {
      let that = this;
			if(that.paramObj.name === ''){
				return that.$message.warning(`请选择考勤状态`)
			}
      let attendance = []
      for(let i in that.paramList){
        let attObj = {
          // date: dayjs.unix(that.paramList[i].date * 1000).format("YYYYMMDD"),
          date: that.paramList[i].date,
          student_sn: that.paramList[i].student_sn,
        }
        attendance.push(attObj)
      }
      let param = {
        practice_plan_id: that.$route.query.plan_id,
				status: that.paramObj.name,
        attendance: attendance,
      };
      console.log("传递",param)
      attendEdit(param).then((res) => {
          if (res.code === 0) {
            that.$message.success("操作成功");
            that.resetForm();
            that.$emit("updRevise", "刷新");
          }
        })
        .catch(() => {});
    },
    //取消
    resetForm() {
      this.reviseDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 30px 20px;
}
::v-deep .el-dialog__header {
  padding: 20px 20px 30px;
}
::v-deep .el-dialog__body {
  padding: 0;
  .el-divider--horizontal {
    margin: 0 0 24px;
  }
}
</style>
